// extracted by mini-css-extract-plugin
export default {"IssueDetailContainer":"IssueDetail-module__IssueDetailContainer--h6eYv"};